export const gallery = [
  {
    image: '/launchpad/stories/reform-dao/gallery/monthly-numbers.png',
    alt: 'monthly numbers',
  },
  {
    image: '/launchpad/stories/reform-dao/gallery/trading-stats.png',
    alt: 'trading stats',
  },
  {
    image: '/launchpad/stories/reform-dao/gallery/public-discount-rate.png',
    alt: 'public discount rate',
  },
  {
    image: '/launchpad/stories/reform-dao/gallery/buy-bonds.png',
    alt: 'buy bonds',
  },
  {
    image: '/launchpad/stories/reform-dao/gallery/staking.png',
    alt: 'staking',
  },
  {
    image: '/launchpad/stories/reform-dao/gallery/pool-staking.png',
    alt: 'pool staking',
  },
];

export const keyFeatures = [
  {
    id: 'ai-powered-market-mining',
    item: (
      <span className="font-normal">
        <span className="font-semibold">AI-Powered Market-Making:&nbsp;</span>
        Operating on both DEXs and CEXs, leveraging machine learning models for high-frequency
        trading and predictive analysis.
      </span>
    ),
  },
  {
    id: 'transparency-dashboard',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Transparency Dashboard:&nbsp;</span>
        Real-time visibility into trading activities, allowing participants to monitor DAO
        performance through a live dashboard and read-only APIs.
      </span>
    ),
  },
  {
    id: 'proven-trading-engine',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Proven Trading Engine:&nbsp;</span>
        Achieved over $3.5 billion in trading volume, capable of executing 3 million trades per day,
        generating consistent profits through strategies like Grid Trading and Dollar-Cost Averaging
        (DCA).
      </span>
    ),
  },
  {
    id: 'revenue-generation',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Revenue Generation:&nbsp;</span>
        $150,000 in revenue generated in the past four months, before token launch, with profits
        directed towards $RFRM token buybacks.
      </span>
    ),
  },
];

export const tractions = [
  {
    id: 'twitter-traction',
    item: (
      <span className="font-normal">
        <span className="font-semibold">130K&nbsp;</span>
        Twitter followers
      </span>
    ),
  },
  {
    id: 'twitter-traction',
    item: (
      <span className="font-normal">
        <span className="font-semibold">90K&nbsp;</span>
        Discord members
      </span>
    ),
  },
  {
    id: 'twitter-traction',
    item: (
      <span className="font-normal">
        <span className="font-semibold">15K&nbsp;</span>
        Telegram members
      </span>
    ),
  },
  {
    id: 'twitter-traction',
    item: (
      <span className="font-normal">
        <span className="font-semibold">10K&nbsp;</span>
        YouTube subscribers
      </span>
    ),
  },
  {
    id: 'twitter-traction',
    item: (
      <span className="font-normal">
        <span className="font-semibold">$3.5 billion&nbsp;</span>
        in trading volume in the past 4 months
      </span>
    ),
  },
  {
    id: 'twitter-traction',
    item: (
      <span className="font-normal">
        <span className="font-semibold">$150,000&nbsp;</span>
        in revenue pre-token launch
      </span>
    ),
  },
];

export const revenues = [
  {
    id: 'value-accural',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Value Accrual:&nbsp;</span>
        Realized Profits from trading activities are used to buy back $RFRM tokens, supporting token
        value.
      </span>
    ),
  },
  {
    id: 'staking-rewards',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Staking Rewards:&nbsp;</span>
        Stake $RFRM to earn rewards in $RFRM and tokens from projects that Reform DAO supports
        through market-making.
      </span>
    ),
  },
  {
    id: 'governance',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Governance:&nbsp;</span>
        Holders of $RFRM tokens gain voting power within the DAO to influence protocol decisions.
      </span>
    ),
  },
];

export const investors = [
  {
    name: 'Hodl Ventures',
    image: 'launchpad/stories/reform-dao/investors/hodl-ventures.png',
    width: 95,
    height: 95,
    className: '',
  },
  {
    name: 'Growity Systems',
    image: 'launchpad/stories/reform-dao/investors/growity-systems.png',
    width: 95,
    height: 95,
    className: '',
  },
  {
    name: 'Arcanum Ventures',
    image: 'launchpad/stories/reform-dao/investors/arcanum-ventures.png',
    width: 95,
    height: 95,
    className: '',
  },
  {
    name: 'Marc van der Chijs (Angel)',
    image: 'launchpad/stories/reform-dao/investors/arc-van-der-chijs.png',
    width: 95,
    height: 95,
    className: '',
  },
];

export const partners = [
  {
    name: 'Bybit',
    image: 'launchpad/stories/reform-dao/partners/bybit.png',
    width: 95,
    height: 95,
    className: '',
  },
  {
    name: 'Venom Chain',
    image: 'launchpad/stories/reform-dao/partners/venom-chain.png',
    width: 95,
    height: 95,
    className: '',
  },
  {
    name: 'DYOR',
    image: 'launchpad/stories/reform-dao/partners/dyor.png',
    width: 95,
    height: 95,
    className: '',
  },
  {
    name: 'Decubate',
    image: 'launchpad/stories/reform-dao/partners/decubate.png',
    width: 95,
    height: 95,
    className: '',
  },
];

export const tokenUtility = [
  {
    id: 'buybacks',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Buybacks:&nbsp;</span>
        Profits from trading are used to buy back $RFRM tokens, enhancing long-term token value.
      </span>
    ),
  },
  {
    id: 'staking',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Staking:&nbsp;</span>
        Stake $RFRM tokens to earn additional rewards.
      </span>
    ),
  },
  {
    id: 'Governance',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Governance:&nbsp;</span>
        Token holders have a say in DAO governance, including decisions on treasury management and
        market-making strategies.
      </span>
    ),
  },
];

export const teamMembers = [
  {
    id: 'ichimoku',
    fullName: 'Ichimoku',
    about: (
      <p className="font-normal">
        10 years of crypto experience, founder of a leading crypto fund in Europe and a
        market-making company.
      </p>
    ),
    width: 104,
    height: 104,
    position: 'Founder & Strategy Lead',
    avatar: '/launchpad/stories/reform-dao/team/ichimoku.png',
  },
  {
    id: 'scorpio',
    fullName: 'Scorpio',
    about: (
      <p className="font-normal">
        7 years in crypto, Head of Trading at a leading European cryptocurrency fund.
      </p>
    ),
    width: 104,
    height: 104,
    position: 'Trading & Business Development',
    avatar: '/launchpad/stories/reform-dao/team/scorpio.png',
  },
  {
    id: 'pauluz',
    fullName: 'Pauluz',
    about: (
      <p className="font-normal">
        4 years in crypto marketing, 7 years of marketing experience overall.
      </p>
    ),
    width: 104,
    height: 104,
    position: 'Marketing Lead',
    avatar: '/launchpad/stories/reform-dao/team/pauluz.png',
  },
];
